import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { TenantThemeProvider } from "@/contexts/TenantThemeContext";
import { PropertyProvider } from "@/contexts/PropertyContext";
import { ProtectedRoute, PublicRoute } from "@/components/RouteGuards";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import CalendarPage from "@/pages/CalendarPage";
import ReservationsPage from "@/pages/ReservationsPage";
import PropertiesPage from "@/pages/PropertiesPage";
import UnitsPage from "@/pages/UnitsPage";
import GuestsPage from "@/pages/GuestsPage";
import ChannelsPage from "@/pages/ChannelsPage";
import SettingsPage from "@/pages/SettingsPage";
import InvoicingSettingsPage from "@/pages/InvoicingSettingsPage";
import RoomTypesPage from "@/pages/RoomTypesPage";
import ThemePage from "@/pages/ThemePage";
import InvoicesPage from "@/pages/InvoicesPage";
import PricingPage from "@/pages/PricingPage";
import EVisitorPage from "@/pages/EVisitorPage";
import InboxPage from "@/pages/InboxPage";
import MessageTemplatesPage from "@/pages/MessageTemplatesPage";
import StatisticsPage from "@/pages/StatisticsPage";
import PublicCheckInPage from "@/pages/PublicCheckInPage";
import PublicPrivacyPage from "@/pages/PublicPrivacyPage";

function App() {
  return (
    <ThemeProvider>
      <Toaster richColors closeButton position="top-right" />
      <AuthProvider>
        <TenantThemeProvider>
          <PropertyProvider>
            <BrowserRouter>
            <Routes>
              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <LoginPage />
                  </PublicRoute>
                }
              />
              <Route
                path="/register"
                element={
                  <PublicRoute>
                    <RegisterPage />
                  </PublicRoute>
                }
              />
              <Route path="/check-in/:tenantSlug" element={<PublicCheckInPage />} />
              <Route path="/check-in/:tenantSlug/p/:propertyId" element={<PublicCheckInPage />} />
              <Route path="/check-in/r/:token" element={<PublicCheckInPage />} />
              <Route path="/check-in/:tenantSlug/privacy" element={<PublicPrivacyPage />} />
              <Route path="/check-in/:tenantSlug/p/:propertyId/privacy" element={<PublicPrivacyPage />} />
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/calendar" element={<CalendarPage />} />
                <Route path="/statistics" element={<StatisticsPage />} />
                <Route path="/reservations" element={<ReservationsPage />} />
                <Route path="/inbox" element={<InboxPage />} />
                <Route path="/settings/templates" element={<MessageTemplatesPage />} />
                <Route path="/settings/invoices" element={<Navigate to="/settings/invoicing" replace />} />
                <Route path="/settings/invoicing" element={<InvoicingSettingsPage />} />
                <Route path="/room-types" element={<RoomTypesPage />} />
                <Route path="/invoices" element={<InvoicesPage />} />
                <Route path="/properties" element={<PropertiesPage />} />
                <Route path="/units" element={<UnitsPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/guests" element={<GuestsPage />} />
                <Route path="/channels" element={<ChannelsPage />} />
                <Route path="/theme" element={<ThemePage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/check-in" element={<EVisitorPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
          </PropertyProvider>
        </TenantThemeProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
